export enum ReportStatus {
  PENDING_REVIEW = "PENDING REVIEW",
  AWAITING_INPUT = "AWAITING INPUT",
  APPROVED = "APPROVED",
  RMS_COMMITTED = "RMS COMMITTED",
  SIGNED = "SIGNED",
  GENERATING = "GENERATING"
}
